import React from 'react'
import './home.css'
import Header from '../Header/Header'
import Hero from '../Hero/Hero'
function home() {
  return (
    <div className='merge-home'>
      <Header/>
      <Hero/>
    </div>
  )
}

export default home
